import { mapGetters } from 'vuex';
import { OverlayScrollbars } from 'overlayscrollbars';
import enLocale from 'element-plus/es/locale/lang/en';
import koLocale from 'element-plus/es/locale/lang/ko';
import AppShell from '@/components/shell/AppShell.vue';
import { LOCALE_KEY, SUPPORTED, setLocale } from '@/locales';
export default {
  components: {
    AppShell
  },
  data() {
    return {
      osInstance: null,
      imageViewerObserver: null
    };
  },
  computed: {
    ...mapGetters(['userConfig', 'useDarkMode']),
    elementLocale() {
      const m = {
        en: enLocale,
        ko: koLocale
      };
      return m[this.$i18n.locale] || enLocale;
    }
  },
  created() {
    try {
      const legacyLocale = localStorage.getItem('locale');
      if (legacyLocale) localStorage.removeItem('locale');
      const saved = localStorage.getItem(LOCALE_KEY);
      if (saved && SUPPORTED.includes(saved)) {
        setLocale(saved);
        return;
      }
      const nav = (navigator.language || '').toLowerCase();
      setLocale(nav.startsWith('ko') ? 'ko' : 'en');
    } catch (e) {
      void e;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initOverlayScrollbars();
      this.setupImageViewerObserver();
    });
  },
  beforeUnmount() {
    if (this.imageViewerObserver) {
      this.imageViewerObserver.disconnect();
    }
  },
  methods: {
    initOverlayScrollbars() {
      try {
        if (OverlayScrollbars.valid(document.body)) {
          this.osInstance = OverlayScrollbars(document.body);
          return;
        }
        this.osInstance = OverlayScrollbars(document.body, {
          scrollbars: {
            theme: 'os-theme-dark',
            visibility: 'auto',
            autoHide: 'scroll',
            autoHideDelay: 600,
            dragScroll: true,
            clickScroll: true
          },
          overflow: {
            x: 'hidden',
            y: 'scroll'
          }
        });
      } catch (error) {
        console.error('Failed to initialize OverlayScrollbars:', error);
      }
    },
    setupImageViewerObserver() {
      this.imageViewerObserver = new MutationObserver(() => {
        const imageViewer = document.querySelector('.el-image-viewer__wrapper');
        if (!this.osInstance) return;
        if (imageViewer) {
          this.osInstance.options({
            overflow: {
              x: 'hidden',
              y: 'hidden'
            }
          });
        } else {
          this.osInstance.options({
            overflow: {
              x: 'hidden',
              y: 'scroll'
            }
          });
        }
      });
      this.imageViewerObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }
};